import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=ef240d44&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=ef240d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef240d44",
  null
  
)

export default component.exports